import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96400122"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_project" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "时间：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "姓名：", -1))
const _hoisted_9 = { class: "header_nr flexAlign" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"120px"}
}, "操作类型：", -1))
const _hoisted_11 = { class: "header_nr flexAlign" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"120px"}
}, "操作明细：", -1))
const _hoisted_13 = {
  class: "header_twonr",
  style: {"margin-top":"20px"}
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_15 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}

import { CirclePlus,Search } from '@element-plus/icons-vue';
	import { reactive,ref,onMounted,nextTick } from 'vue';
	import { requestGetLogList } from '@/api/api';
	import { ElMessage } from 'element-plus';
	
export default /*#__PURE__*/_defineComponent({
  name: 'Loglist',
  setup(__props) {

	const loading = ref(false)
	const tableData = ref([])
	const pageIndex = ref(1)
	const pageSize = ref(10)
	const pages = ref({
		totalCount:0
	})
	const search = ref({
		createtime:'',
		actionusername:'',
		actiontype:'',
		actiontext:'',
	})//搜索
	onMounted(()=>{
		getLogList();
	})
	const getLogList = () =>{
		loading.value = true
		requestGetLogList({
			pageIndex:pageIndex.value,
			pageSize:pageSize.value,
			createtime:search.value.createtime,
			actionusername:search.value.actionusername,
			actiontype:search.value.actiontype,
			actiontext:search.value.actiontext,
		}).then((res:any)=>{
			tableData.value = res.data
			pages.value.totalCount = res.totalCount
			loading.value = false
		})
	}
	
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getLogList();
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getLogList();
	}
	const searchList = () =>{
		pageIndex.value = 1
		getLogList();
	}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.createtime,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.createtime) = $event)),
              style: {width:'150px'},
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.actionusername,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.value.actionusername) = $event)),
              style: {width:'150px'},
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.actiontype,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search.value.actiontype) = $event)),
              style: {width:'150px'},
              onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.actiontext,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((search.value.actiontext) = $event)),
              style: {width:'150px'},
              onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (searchList())),
            size: "small",
            icon: _unref(Search),
            type: "primary",
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["icon"])
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      onCellClick: _ctx.details,
      "empty-text": "暂无数据",
      data: tableData.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "80",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.createtime",
          label: "时间",
          width: "160"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.actionusername",
          label: "姓名",
          width: "160"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.actiontype",
          label: "操作类型",
          width: "160"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.actiontext",
          label: "操作明细"
        })
      ]),
      _: 1
    }, 8, ["onCellClick", "data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[10] || (_cache[10] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ])
  ]))
}
}

})